
import { Lead } from '../types';

/**
 * Pushes a new lead to the Google Sheet via the Apps Script Web App.
 * @param url The Google Apps Script Web App URL
 * @param lead The lead data to send
 * @param guestCount Optional guest count to override summary parsing
 */
export const pushLeadToSheet = async (url: string, lead: Lead, guestCount?: string | number) => {
    if (!url) return;

    const payload = {
        id: lead.id,
        name: lead.name,
        phone: lead.phone,
        date: lead.eventDate,
        guests: guestCount || "See Summary",
        summary: lead.summary
    };

    try {
        // IMPORTANT: We use mode 'no-cors' to avoid CORS errors from Google's side.
        // However, 'no-cors' prevents reading the response and also restricts headers.
        // We MUST NOT set 'Content-Type': 'application/json' because that triggers a preflight
        // check which often fails or is complex with GAS.
        // Instead, we send the body as a plain string. The GAS `doPost(e)` will receive it 
        // in `e.postData.contents`.
        await fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            body: JSON.stringify(payload)
        });
        console.log("Synced to Google Sheet");
    } catch (e) {
        console.error("Sheet Sync Failed", e);
    }
};

/**
 * Fetches leads from the Google Sheet.
 * @param url The Google Apps Script Web App URL
 * @returns Array of raw lead objects from sheet
 */
export const fetchLeadsFromSheet = async (url: string): Promise<any[]> => {
    if (!url) return [];

    try {
        const response = await fetch(url);
        const data = await response.json();
        return data;
    } catch (e) {
        console.error("Failed to fetch from Sheet", e);
        return [];
    }
};
